module.exports = __webpack_public_path__ + "static/media/chloropleth.b095fb00.svg";